/* eslint-disable no-unused-vars */
import React from 'react';
import { Box, Button } from '@mui/material';
// import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';

import moment from 'moment';

const Header = ({ isTrial, expire }) => {
    return (
        <>
            {isTrial && (
                <Button variant="contained" color="primary" sx={{ width: { xs: '100%', sm: 'auto' }, mb: { xs: 1, sm: 0 } }}>
                    {expire ? moment(expire).diff(moment(), 'days') : 0} days left in trial
                </Button>
            )}
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }}> </Box> */}
            <Box sx={{ marginRight: 1, flexGrow: 1, pl: 2, display: { xs: 'none', sm: 'block' } }} />
            <ProfileSection />
        </>
    );
};

export default Header;
